type GraphqlDocumentLike = {
  readonly definitions: readonly {
    readonly kind: string;
    readonly name?: { readonly value: string } | null;
  }[];
};

/** Operation name from a parsed GraphQL document, if the primary operation is named. */
export function getGraphqlOperationName(
  document: GraphqlDocumentLike,
): string | undefined {
  const operation = document.definitions.find(
    (definition) => definition.kind === 'OperationDefinition',
  );

  return operation?.name?.value;
}
